// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__c0yY6","inputWrap":"styles_inputWrap__2xacF","input":"styles_input__lmxz3"};